import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-10 w-10" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#C8553D" />
    <path d="M40 14a18 18 0 1 0 0 36 20 20 0 0 1-12-4.4A22 22 0 0 0 40 14z" fill="#FFF8E7" />
    <path d="M44 26c4-1 7-4 8-8-4 0-8 2-10 6" fill="#D4A017" />
    <text x="30" y="42" fontFamily="Georgia, serif" fontSize="20" fontWeight="700" fill="#5C1F1A" textAnchor="middle">TN</text>
  </svg>
);

export const Logo = ({ variant = "dark", href = "/" }) => {
  const textColor = variant === "light" ? "text-cream" : "text-encre";
  const subColor = variant === "light" ? "text-cream/70" : "text-taupe";
  return (
    <Link to={href} className="flex items-center gap-3" data-testid="logo-link" aria-label="TN FOOD — Accueil">
      <LogoMark />
      <span className="leading-tight">
        <span className={`block font-display text-xl font-bold tracking-wide ${textColor}`}>TN FOOD</span>
        <span className={`block text-[11px] uppercase tracking-[0.2em] ${subColor}`}>Cuisine tunisienne</span>
      </span>
    </Link>
  );
};
